<template>
  <div>
    <b-form @submit="preventDefault">
      <b-form-group
          id="input-group-1"
          description="Vous pouvez chercher une action par mot clé."
          label-for="input-1"
      >
        <b-form-input
            id="input-1"
            v-model="motRecherche"
            placeholder="Recherche par action.."
            required
            type="text"
            v-on:keydown.enter.prevent="preventDefault"
            @keyup="toRegex"
        ></b-form-input>
      </b-form-group>
    </b-form>

    <div v-show="showResult">
      <h2>Selectionner l'action</h2>
      <div class="icon-list">
        <div v-for="action in filteredActions" :key="action.id" class="amsom-button"
             @click="setAllCategorisationAndRedirectToFormulaire(action.id)">
          <button class="btn btn-secondary">
            <i :class="fontawesomeico(action.id)"></i>
          </button>
          <span class="amsom-button-libelle">{{ action.libelle }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import regexNormalize from "@/js/regex";

export default {
  name: "RechercheAction",
  data() {
    return {
      motRecherche: "",
      rechercheRegex: null
    }
  },
  methods: {
    fontawesomeico(ID) {
      if (ID === "TECH") return 'fas fa-tools'
      return 'fas fa-cog'
    },
    toRegex(){
      this.rechercheRegex = regexNormalize(this.motRecherche)
    },
    setAllCategorisationAndRedirectToFormulaire(actionID) {
      // On recupere les ID de categorisation
      let evenement = this.$store.getters['actions/getActionById'](actionID).evenement

      // On fixe la categorisation selectionne dans chacun des store
      this.$store.dispatch('actions/setSelectedAction', actionID)
      this.$store.dispatch('evenements/setSelectedEvenement', evenement)

      // On redirige vers la selection de l'adresse
      this.$router.push({name: 'formulairesuivi'})
    },
    preventDefault(e) {
      e.preventDefault()
    }

  },
  computed: {
    actions() {
      return this.$store.getters['actions/iCanWrite']
    },
    filteredActions() {
      if (this.actions != null && this.rechercheRegex != null) {

        let r = this.rechercheRegex
        return this.actions.filter(
            action =>
                action.libelle.toLowerCase().replace(/\s/g, "").includes(r)
        )
      } else
        return null
    },
    showResult() {
      if (this.filteredActions != null && this.motRecherche.length > 0) return true
      else return false
    }
  }
}
</script>

<style scoped>

</style>